export default "__VITE_ASSET__51fbc2a0__"